import { isHttpError } from "~/utils/httpClient";

export const signInConnectionMessage =
  "We couldn't connect. Check your internet connection and try again.";

// Browser connectivity is only a hint; classify the actual request failure.
export const isSignInConnectionError = (error: unknown) =>
  (typeof error === "object" &&
    error !== null &&
    "code" in error &&
    error.code === "auth/network-request-failed") ||
  (isHttpError(error) &&
    ["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"].includes(error.code ?? ""));
